// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"316":"ad2866b8","501":"bc98253f","930":"164f4fb6"}[chunkId] || chunkId) + "." + {"7":"7c3e20994b1f7af7","316":"83f2bbcd93d01219","501":"d13bf505216111a2","756":"aab1dded6ccca12e","839":"852c6c7e965ce7ee","930":"bebdecf7034b4b1c","995":"756f0269cc193e7e"}[chunkId] + ".js";
};